"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";

/** Error banner for login page */
export function LoginErrorBanner(t0) {
  const $ = _c(4);
  const {
    error,
    oauthClientError,
    clientProfileError
  } = t0;
  const message = error || oauthClientError?.message || clientProfileError?.message;
  let t1;
  if ($[0] !== message) {
    t1 = message ? <Alert variant="destructive"><AlertDescription>{message}</AlertDescription></Alert> : null;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="h-44 overflow-y-auto pt-3" data-testid="login-error-region">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}